import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth

  useEffect(() => {
    let cancelled = false;
    const timeout = setTimeout(() => {
      if (!cancelled) setUser(false);
    }, 15000);
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch {
        if (!cancelled) setUser(false);
      } finally {
        clearTimeout(timeout);
      }
    })();
    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, []);

  const completeSession = (data) => {
    if (data.token) localStorage.setItem("mt5_token", data.token);
    setUser(data);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_mfa) {
      return { requiresMfa: true, ...data };
    }
    return completeSession(data);
  };

  const verifyMfa = async (mfaToken, code) => {
    const { data } = await api.post("/auth/verify-mfa", {
      mfa_token: mfaToken,
      code,
    });
    return completeSession(data);
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return completeSession(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("mt5_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, verifyMfa, register, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
